module.exports = __webpack_public_path__ + "img/dance-school-icon9.e9908115.png";